module.exports = __webpack_public_path__ + "static/media/Bettdecke_140x200.2105f060.png";